import { useTranslation } from "react-i18next";

function BulkProductsHeader({ title, currentStep, hasDes = false }) {
  const { t } = useTranslation("addProductsHeader");

  const steps = [
    {
      number: 1,
      key: "introductions",
      label: t("steps.introductions", "Introductions")
    },
    {
      number: 2,
      key: "uploadFile",
      label: t("steps.uploadFile", "Upload file")
    },
    {
      number: 3,
      key: "reviewProducts",
      label: t("steps.reviewProducts", "Review Products")
    },
    {
      number: 4,
      key: "publishToMarketplace",
      label: t("steps.publishToMarketplace", "Publish to Marketplace")
    }
  ];

  const getStepStatus = (stepNumber) => {
    if (stepNumber < currentStep) return "completed";
    if (stepNumber === currentStep) return "active";
    // if step 4 and current step is 4, mark completed
    if (currentStep === 4) return "completed";
    return "inactive";
  };

  const getStepClasses = (status) => {
    const baseClasses = "w-[48px] h-[48px] rounded-full border flex items-center justify-center text-sm font-semibold transition-all duration-200";
    
    switch (status) {
      case "completed":
        return `${baseClasses} bg-[#6609F8] text-white border-[#EBE5FF]`;
      case "active":
        return `${baseClasses} bg-[#FFFFFF]  text-[#6609F8] border-[#6609F8] border-2`;
      case "inactive":
        return `${baseClasses} bg-[#FFFFFF] text-gray-500 border-[#EBE5FF]`;
      default:
        return `${baseClasses} bg-[#FFFFFF] text-gray-500 border-[#EBE5FF]`;
    }
  };

 
  return (
    <div className="w-full mb-8">
      {/* Title and Description */}
      <div className="flex flex-col justify-center gap-2 mb-[48px] border-b border-[#6609F8] pb-[68px]">
        <h1 className="text-[24px] font-[900] text-text-dark tracking-[-0.5px]">
          {t("addProductsHeader.description", title)}
        </h1>
        {hasDes && (
          <p className="text-[16px] font-normal text-text-medium">
            {t("addProductsHeader.bulkProductsHeader.description")}
          </p>
        )}
      </div>

      {/* Stepper */}
      <div className="w-full">
       {/* Bulk Products uploader */}
       <h1 className="text-[24px] font-[700] text-text-dark mb-[32px] text-center">
          {t("addProductsHeader.bulkUploadTitle", "Bulk Products Uploader")}
        </h1>

        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div key={step.key} className="flex items-center flex-1">
              {/* Step Circle */}
              <div className="flex flex-row items-center gap-[8px]">
                <div className={getStepClasses(getStepStatus(step.number))}>
                  {step.number}
                </div>
             

                <span className="whitespace-nowrap  text-[18px] font-semibold text-[#292929]">
                  {step.label}
                </span>
              </div>
              
              
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BulkProductsHeader;